import { HttpHeaders } from "@angular/common/http";
import { AppService } from "app/services/app.service";

import { Camera } from "app/models/camera.model";
import { ConfigCameras } from "app/models/configcamera.model";
import { Observable } from "rxjs";

export abstract class AbCameras extends AppService {
  abstract getAllCameras(): Observable<any>;
  abstract getAllCamerasSemCFTV(): Observable<any>;
  abstract findAllCameras(): Observable<any>;
  abstract findCftvAllCameras(id: number): Observable<any>;
  abstract restauraCameraDeletada(id: number): Observable<any>;
  abstract findAllBySistemaVms(sistemavms: string): Observable<any>;
  abstract saveCameras(cameras: Camera[]): Observable<any>;
  abstract saveCamerasGrupos(cameras: Camera[]): Observable<any>;
  abstract saveCamerasLPR(cameras: Camera[]): Observable<any>;
  abstract deletar(id: number);
  abstract deletarTodos(camerasIds: number[]);
  abstract getImagemCamera(config: ConfigCameras, cameraId: string, sessionId: string): Observable<any>;
  abstract getImagemCameraPrincipal(params: any, sessionId: string): Observable<any>;
  abstract getImagemCameraDguardNovaAPI(config: ConfigCameras, cameraId: string): Observable<any>;
  abstract getHeaders(sessionId, params): HttpHeaders;
  abstract getSnapshotDigfort(params: any): Promise<string>;
  abstract getStreamUrlDigfort(paramsCamera): Promise<string>;
  abstract getStreamReaderDigfort(params: any): Promise<ReadableStreamDefaultReader<Uint8Array>>;
  abstract cancelStreamDigfort(): void;
  abstract getImagemSigMainThumbnailJpg(token: string, servidorCamera: string, codigoCamera: string): Observable<any>;
  abstract getImagemSigMainPlaylist(token: string, servidorCamera: string, codigoCamera: string): Observable<any>;
}
